import React, { useContext, useEffect, useState } from 'react';

import Classes from './Hero.module.scss';
import headerLogo from '../../../../images/landing-page/overdrive/icons/mp-icon-header-overdrive.svg';
import { Image } from '@hz-design-system/web-ui';
import EnvironmentContext from '../../../contexts/EnvironmentContext';
import getStaticImageUrl from '../../../utils/getStaticImageUrl';

let imgSrc;

const texts = {
  toys: [
    'Het speelgoed van een ander',
    'is altijd leuker',
    'Je herkent vast wel dat kinderen altijd het liefst spelen met het speelgoed van een ander. Gelukkig staat Marktplaats daar vol mee! Doe hier inspiratie op, stel filters in en maak een verlanglijstje door de advertenties aan je favorieten toe te voegen. Veel plezier!',
  ],
  'car-upgrade': ['Bij één van de 7.000 autobedrijven kopen', 'Ook slim', ''],
  'upgrade-auto': [
    'Misschien is het tijd',
    'voor een upgrade van je auto',
    'Of je nu zoekt naar nieuwer, zuiniger of ruimer, jouw volgende auto vind je hier: tussen het aanbod van ruim 7000 betrouwbare autobedrijven en -dealers.',
  ],
  overdrive: [
    'Krijg tijdelijk',
    '€1.000 EV-korting',
    'De populaire SEPP-subsidie voor elektrische auto’s liep precies een jaar geleden af. Maar goed nieuws: wij helpen je alsnog de stap naar elektrisch rijden te maken. Daarom geven wij je tijdelijk €1.000 korting op een elektrische occasion van elk autobedrijf op Marktplaats! Bekijk snel het beschikbare budget en hoe je jouw korting claimt.',
  ],
};

type TParams = {
  pageKey: string;
};

const Hero = ({ pageKey }: TParams) => {
  const { staticBaseUrl } = useContext(EnvironmentContext);
  const [heroLoaded, setHeroLoaded] = useState<boolean>(false);
  const withIcon = pageKey === 'overdrive';
  const imageAsBackground = pageKey === 'overdrive' || pageKey === 'car-upgrade';

  useEffect(() => {
    void (async () => {
      try {
        if (pageKey === 'toys') {
          imgSrc = (await import(/* webpackChunkName: "toysHero" */ '../../../../images/toys-page/toys-hero.webp'))
            .default;
        } else if (pageKey === 'overdrive') {
          imgSrc = (
            await import(
              /* webpackChunkName: "overdriveHero" */ '../../../../images/landing-page/overdrive/headers/mp-header-desktop.webp'
            )
          ).default;
        } else {
          imgSrc = (
            await import(/* webpackChunkName: "carUpgradeHero" */ '../../../../images/toys-page/car-upgrade-hero.webp')
          ).default;
        }
        setHeroLoaded(true);
      } catch {}
    })();
  }, [pageKey]);

  return (
    <div className={Classes.root}>
      <div className={`hz-Page-content ${Classes.content}`}>
        {withIcon && (
          <div className={Classes.withIcon}>
            <Image className={Classes.icon} alt="Pagina logo" src={getStaticImageUrl(staticBaseUrl, headerLogo)} />
            <h1 className={`hz-Title ${Classes.title}`}>
              <span className={Classes.line1}>{texts[pageKey][0]}</span>
              <span className={Classes.line2}>{texts[pageKey][1]}</span>
            </h1>
          </div>
        )}
        {!withIcon && (
          <h1 className={`hz-Title ${Classes.title}`}>
            <span className={Classes.line1}>{texts[pageKey][0]}</span>
            <span className={Classes.line2}>{texts[pageKey][1]}</span>
          </h1>
        )}
        <p className={Classes.body}>{texts[pageKey][2]}</p>
      </div>
      {imageAsBackground && <div className={Classes.imageBackground} />}
      {!imageAsBackground && heroLoaded && <img className={Classes.image} src={imgSrc} alt="achtergrond afbeelding" />}
    </div>
  );
};

export default Hero;
